import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {Skeleton} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', (
        _$cc(Skeleton, {
            'loading': this.get('showSkeleton'),
            'avator': true,
            'animated': true
        })
    ), 2 /* HasVNodeChildren */);
};